/**
 * AntragFristDialog - «Frist anpassen» (Tab 5a, P2 Slice 13). Sets a new signature Frist.
 */

import { useState } from 'react';
import type { AntragFristBody } from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function AntragFristDialog({
  open,
  onClose,
  currentFrist,
  onFrist,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  currentFrist: string | null;
  onFrist: (body: AntragFristBody) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const [frist, setFrist] = useState(currentFrist ?? '');
  const errorText = error?.code === 'frist_invalid' ? 'Die Frist muss in der Zukunft liegen' : error?.code ? 'Frist konnte nicht angepasst werden' : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Frist anpassen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving || frist.trim() === ''} onClick={() => onFrist({ frist_date: frist })} data-testid="antrag-frist-submit">
            Frist anpassen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="antrag-frist-dialog">
        <label className="block">
          <span className="text-xs text-muted-foreground">Neue Frist</span>
          <input type="date" value={frist} onChange={(e) => setFrist(e.target.value)} className="mt-1 w-full rounded-md border border-border p-2" data-testid="antrag-frist-date-input" />
        </label>
        {errorText && <p className="text-sm text-status-danger" data-testid="antrag-frist-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
